import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, WidthType } from "docx";

export const aboutHeading = new Paragraph({
    spacing: { before: 150 },
    children: [new TextRun({
        text: "1.  About ISECURION",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})

export const aboutPage1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 250, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "ISECURION Technology and Consulting Pvt Ltd is an ISO 27001:2022 Certified Company. As per consultants magazine we are among the top 10 IT security consulting companies in India. With a highly competent team we are committed to provide highest quality Information Security Services that reflects in our vision statement.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const aboutPage2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 250, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "ISECURION has been empanelled as IT Security Audit Organization by the CERT-In, Ministry of Information Technology, Govt. of India and the CCA, Ministry of Information Technology, Govt. of India.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const aboutPage3 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 250, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "CERT-In is operational since January 2004. The constituency of CERT-In is the Indian Cyber Community. CERT-In is the national nodal agency for responding to computer security incidents as and when they occur.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const aboutPage4 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 250, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "In the recent Information Technology amendment act 2008, CERT-In has been designated to serve as the national agency to perform the following functions in the area of cyber security:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const bulletOne = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Collection, analysis and dissemination of information on cyber incidents.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const bulletTwo = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Forecast and alerts of cyber security incidents.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const bulletThree = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Emergency measures for handling cyber security incidents.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const bulletfour = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Coordination of cyber incident response activities.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const bulletfive = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Issue guidelines, advisories, vulnerability notes and whitepapers relating to in Prevention, response and reporting of cyber incidents.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const bulletsix = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Such other functions relating to cyber security as may be prescribed.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})
